import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth43: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29,370h0c45.7-34.7,80.1,2.2,80.1,2.2l3.4,13.3,8.5,28.1,3.7,16.8.2,21.8-1.2,6.6-1.5,13.4-6.4,16-9.5,11.4-13.9,5.4-10.8,2.2-7.6-.2-14.1-4.5-30-19.3-6.9-9.1-6.8-8.9-4.4-14.9-1-9.9.8-19.7,3.1-12.7,3.6-9.1,4.5-10.1,4.6-11.2,1.6-7.6h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M108.3,362.2c-40.6-31.8-77.4-1.1-77.4-1.1l-1.9,8.9c45.6-34.6,80.1,2.2,80.1,2.2,0,0-.8-10-.8-10Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.2,455.6h-.1c-62.2-20.8-6.4-53.2-6.4-53.2l6.3,26.8.5,11.5-.3,15h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.5,398.8h0c52.8,37.1-5.7,52.2-5.7,52.2l-1.7-9.4.7-18.8,1.7-10.4,5-13.6h0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M84.4,505.9c-19.7-56.5,28.2-120.8,28.2-120.8l4.9,17.3,6.3,26.8.5,11.5-.3,15-1.5,14.9-6.3,17.4-11.1,11.6-13.4,5.5-7.1.8h-.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.6,377.5c49.4,82.1,34.9,125.8,34.9,125.8l-17.6-9.2-15.5-11.1-12.2-15.5-2.7-7.6-1.7-8.9-1.7-9.4.7-18.8,1.7-10.4,5-13.6,4.6-10.9,4.6-10.3h-.1Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M83.1,415.1a12.5,12.5 0 1,1 -25,0a12.5,12.5 0 1,1 25,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '121.1 475.9 115.9 488.1 106 499.9 91.9 505.5 83.2 506.8 73.3 506.9 59.7 502.4 47.6 495.5 30.8 484.1 18 467.6 122.7 467.6 121.1 475.9',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29,370h0c45.7-34.7,80.1,2.2,80.1,2.2l3.4,13.3,8.5,28.1,3.7,16.8.2,21.8-1.2,6.6-1.5,13.4-6.4,16-9.5,11.4-13.9,5.4-10.8,2.2-7.6-.2-14.1-4.5-30-19.3-6.9-9.1-6.8-8.9-4.4-14.9-1-9.9.8-19.7,3.1-12.7,3.6-9.1,4.5-10.1,4.6-11.2,1.6-7.6h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'13.6 442.8 24.8 425.6 30.4 449.6 37.9 420.4 47.7 450.3 56.7 420.4 66.8 450 76.1 420.4 86.3 451.8 94.5 421.9 105.4 451.8 108.7 426.7 122.6 442.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'70 364.9 76.8 358.1 68.9 350.2 75.8 343.3 68.5 336 75 329.4 68.5 322.9 74.8 316.5 67.3 309 73.5 302.9 67.5 296.9 73.7 290.7 67.1 284.2 73.7 277.6 67.5 271.5 74.1 264.9 68.3 259.1 74.7 252.7 67.7 245.7 75.2 238.2 68.5 231.4 75.9 224 68.9 217.1 76.2 209.8 68.3 201.9 75 195.1 67.6 187.7 75.6 179.8 68.6 172.8 75.8 165.6 68.4 158.3 76 150.6 68.7 143.3 75.8 136.3 68.2 128.7 75.3 121.5 67.8 114 74.9 106.9 67.2 91',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'51.7 216.7 53.9 210.1 57.5 217.5 61.2 210.8 65.6 217 70.9 209.7 75.7 218.4 81.5 210.1 87.2 218.4 91.9 210.8 96.9 218.2',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '112 122.2 107 131.9 102.8 140.1 97.9 145.2 88.3 151.8 78.8 155.7 60.8 155.4 41.1 144.9 35.2 139.8 30.4 136.5 23 132.2 12.4 120.1 11.2 115 11.2 104.5 12 100.9 15.7 89.7 18.4 84.3 26 75.1 39 62.5 41.1 61 46.8 56.8 53.6 53.8 61.6 50.4 68.8 50 81.9 55.8 88.5 61.7 100.8 74.8 109.3 87.8 113.9 101.9 113.9 114.5 112 122.2',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.3,132.3l56.9.6c-28.6,28.6-56.9-.6-56.9-.6Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.4,89.3l4.6,12.5.3,10.2-3.7,12.9c-48-16.8-1.2-35.6-1.2-35.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M15.9,88.7c45.8,18.8.3,36.4.3,36.4l-5.6-9.7.2-12.9.8-3.4,4.3-10.5h0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '15.9 88.6 10.8 102.5 10.6 115.4 16.2 125 110.6 124.9 114.4 112 114 101.8 109.4 89.3 15.9 88.6',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.9,114.5c-59.8,17.4-102.7.5-102.7.5l1.2,5.1,10.6,12.1,12.2,7.6,5.9,5.1,19.7,10.5,18,.3,9.5-3.9,9.6-6.6,4.9-5.1,4.2-8.2,5-9.7,1.9-7.7h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.2,115v-10.5s.8-3.6.8-3.6l3.7-11.2,2.7-5.4,7.6-9.2,15.1-14.1,5.7-4.2,6.8-3,8-3.4,7.2-.4,13.1,5.8,6.6,5.9,12.3,13.1,8.5,13,4.6,14.1v12.6c-60,17.4-102.7.5-102.7.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'12.4 101.6 22.8 117.5 28 95.4 34.9 122.4 43.9 94.7 52.3 122.4 61.6 95 70.3 122.4 79.6 93.3 87.3 121 97.3 93.3 100.4 116.5 113.3 102.3',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107.2,144.6s-39.7,30.8-82.1-.6l-1.7-8-2-5.7-3.7-8.8-3.5-7.2-4.4-12.3-3-11.1-.9-10.3v-19.7s7.1-19.2,7.1-19.2l11.1-13.6,10.1-8.6,12.8-8.6,12.3-6.4,14.6-3.7,17.7,3.7,14.5,7.8,9.4,12.4,3.7,10.1,1.9,12,1.3,10.4.7,19.9-1,7.7-1.7,10.1-3.4,14.7-4,15.3-3.9,11.3-1.9,8.4h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.7,154.5c-44.2,26.7-80.6.1-80.6.1l-1-10.6c42.3,31.4,82.1.6,82.1.6l-.5,9.9Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '13.9 38.9 21.6 28.6 28.8 21.9 39.2 14.6 49.8 8.3 58.2 4.4 64.5 2.4 73.3 1.1 82.3 1.8 91.5 3.5 105.1 9.8 112.6 19.6 116.8 27.3 120.6 39.9 13.9 38.9',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M45,96.1l44.4-.2c-24.2,109.8-44.4.2-44.4.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.9,39.3c-68.3,25.7,1.5,52.4,1.5,52.4l1.6-15.3-.2-20.8-2.8-16.3h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M7.1,90.8l-1.2-8.2.4-17.9.4-4.9,5.3-16.7,4.5-5.5c58.3,29.6-9.4,53.2-9.4,53.2Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M108.4,135.7l4.9-11.4,4.9-16.9,3.2-15.7,1.6-15.3-.2-20.8-2.8-16.3-5.5-17.1-8.8-11-9.4-5.3-13.2-3.1c-16.7,36.3,25.3,132.9,25.3,132.9Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.4,134.7l-8.4-19.4-5.5-13.9-2.4-10.6-1.2-8.2.8-22.8,5.3-16.7,4.5-5.5,6.3-9.2,11.6-9.2,10.6-6.9,10.8-6.1,9-2.2c-1.2,57.9-41.4,130.7-41.4,130.7Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107.2,144.6s-39.7,30.8-82.1-.6l-1.7-8-2-5.7-3.7-8.8-3.5-7.2-4.4-12.3-3-11.1-.9-10.3v-19.7s7.1-19.2,7.1-19.2l11.1-13.6,10.1-8.6,12.8-8.6,12.3-6.4,14.6-3.7,17.7,3.7,14.5,7.8,9.4,12.4,3.7,10.1,1.9,12,1.3,10.4.7,19.9-1,7.7-1.7,10.1-3.4,14.7-4,15.3-3.9,11.3-1.9,8.4h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'6.8 71 18.6 89 24.5 63.9 32.3 94.5 42.5 63.1 52 94.5 62.6 63.5 72.4 94.5 83 61.5 91.6 92.9 103 61.5 106.5 87.8 121 71.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'67.6 154.4 61.5 160.4 68.5 167.6 62.2 173.8 68.7 180.4 62.8 186.2 68.6 192.2 62.8 197.8 69.5 204.6 63.9 210.1 69.2 215.5 63.6 221 69.4 227 63.5 232.8 69 238.4 63 244.2 68.1 249.4 62.3 255.2 68.5 261.5 61.7 268.2 67.7 274.3 61 280.9 67.1 287.2 60.5 293.7 67.6 300.9 61.5 306.9 68 313.6 60.8 320.6 67 327 60.5 333.3 67.1 340.1 60.1 346.8 66.6 353.4 60.2 359.7 67 366.6 60.5 373 67.1 379.8 60.7 386.1 67.5 400.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'46.8 284.4 49.9 291.6 53.5 284 57.3 290.9 61.8 284.6 67.2 292 72.1 283.1 78 291.6 83.8 283.1 88.7 290.9 93.7 283.3',
			],
		},
	},
};
